import React, { useEffect, useState } from 'react'
import { Flex, Flexed, MainWrap, Scroll, currency } from '../../utilities/Shared'
import { Link, useNavigate } from 'react-router-dom'
import { sortdate, sortit, sortnum } from '../../utilities/Sort'
import Moment from 'react-moment'
import PrintComponent from '../../Printing/Activejobs';
import axios from 'axios';


// const ActiveJobs = ({order,activejobs,setActivejobs,setOrder,getactivesales,getDuedateMinusDay,getemployeebyoldid,billableitem,salesreps}) => {
  const ActiveJobs = ({order,setOrder,getactivesales,getDuedateMinusDay,getemployeebyoldid,billableitem,salesreps}) => {
  const[newjobs, setNewjobs] = useState([])
  const[activejobs, setActivejobs] = useState([])
  const[reset, setReset] = useState(true)

  // useEffect(() => {
  //   let ee = 0;
    
  //   const processJobs = async () => {
  //     const updatedJobs = await Promise.all(
  //       activejobs.map(async (job) => {
  //         ee += parseFloat(job.currentprice);
  //         const tempbill = await billableforyesturday(job); // Await the async function
  //         return { ...job, tempbill }; // Return updated job object
  //       })
  //     );
  //     setNewjobs(updatedJobs);
  //   };
  //   processJobs();
  // },[activejobs])

useEffect(() => {

const getopen = async() => {
const jobs = await axios.post('https://highgroundapi.herokuapp.com/jobs/openjobs')
.then(res => {
  console.log(res.data)
  setActivejobs(res.data)

})
.catch(err => console.log(err))
}

getopen()
},[reset])

  const billableforyesturday = (job) => {
    let u  = 0
     job?.billable?.map(bill => {
       u += parseFloat(bill.cost)
     })
     return u
   }

   const [columnVisibility, setColumnVisibility] = useState({
      job: true,
      po:true,
      customer: true,
      jobname: true,
      quantity: true,
      dateentered: true,
      duedate: true,
      salesrep:true,
     // csrSalesRep: userInfo.departments?.some(item => item.label === "CSR"),
      //status: true,
      sales:true
    });


    const toggleColumn = (column) => {
      setColumnVisibility((prev) => ({
        ...prev,
        [column]: !prev[column],
      }));
    };

const billable= (bills) => {

let h = 0

bills.map(bill => {
  h += parseFloat(bill?.cost) || 0
})
return h
}

  return (
    <>
    <Flexed  margin="30px 0px 0px 0px" bgColor="#8398AB" color="white"  padding="5px"><Flex fontSize="calc(1.1rem + .4vw)">PLS Active Jobs - {activejobs?.length}</Flex><Flex fontSize="calc(1.1rem + .4vw)" textAlign="right">${currency(getactivesales())}</Flex></Flexed>
    <Flexed padding="10px 0px 0px 0px">
    {Object.keys(columnVisibility).map((column) => (
                   <Flex> <label
                                    key={column}
                                    style={{
                                      alignItems: 'center',
                                      marginRight: '15px',
                                      whiteSpace: 'nowrap'
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={columnVisibility[column]}
                                      onChange={() => toggleColumn(column)}
                                      style={{ marginRight: '5px' }}
                                    />
                                    {column.charAt(0).toUpperCase() + column.slice(1)}
                                  </label>
                                  </Flex>
                  ))}
                  <Flex flex="1.5"> <PrintComponent
                  csrjobs={activejobs}
                salesreps={salesreps}
               // csrjobs={csrjobs}
                title={`Active Jobs`}
                columnVisibility={columnVisibility}
              /></Flex>
    </Flexed>
    
    
    <Flexed style={{borderBottom:"1px solid black",padding:"4px",background:"white"}} className="hand">
    
      <Flex flex=".5" fontSize="var(--headerMedium)" onClick={e => sortnum('job',order,activejobs,setActivejobs,setOrder)}>Job#</Flex>
      
      <Flex fontSize="var(--headerMedium)" onClick={e => sortit('custpo',order,activejobs,setActivejobs,setOrder)}>Cust PO#</Flex>
      <Flex flex="1.5" fontSize="var(--headerMedium)" onClick={e => sortit('customer',order,activejobs,setActivejobs,setOrder)}>Customer</Flex>
      <Flex  flex="3" fontSize="var(--headerMedium)" onClick={e => sortit('jobname',order,activejobs,setActivejobs,setOrder)}>Job Name</Flex>
      <Flex  fontSize="var(--headerMedium)" onClick={e => sortnum('origquantity',order,activejobs,setActivejobs,setOrder)}>Quantity</Flex>
      <Flex  fontSize="var(--headerMedium)" onClick={e => sortdate('dateentered',order,activejobs,setActivejobs,setOrder)}>Entered</Flex>
      <Flex  fontSize="var(--headerMedium)" onClick={e => sortdate('duedate',order,activejobs,setActivejobs,setOrder)}>Due</Flex>
      <Flex  fontSize="var(--headerMedium)" onClick={e => sortit('salesrep',order,activejobs,setActivejobs,setOrder)}>Sales Rep</Flex>
      <Flex  fontSize="var(--headerMedium)" onClick={e => sortit('currentprice',order,activejobs,setActivejobs,setOrder)}>Sales $</Flex>
      <Flex flex=".1"></Flex>
    </Flexed>
    <Scroll  height="350px" border="1px solid #303030">
    {
     activejobs?.map(job => {
        return <Flexed className="normalrow hand" padding="5px" >
          <Flex flex=".5"><Link to={`/jobticket/${job.job}`}>{job.job} </Link></Flex>
          <Flex >{job.custpo}</Flex>
          <Flex flex="1.5">{job.customer}</Flex>
          <Flex flex="3">{job.jobname}</Flex>
          <Flex>{job.quantity === "0" ? job.origquantity : job.quantity}</Flex>
          <Flex><Moment format="MM/DD/YYYY">{job.dateentered}</Moment></Flex>
          <Flex><Moment format="MM/DD/YYYY">{getDuedateMinusDay(job.duedate)}</Moment></Flex>
          <Flex>{getemployeebyoldid(job.salesrep)}</Flex>
          <Flex>{job.customerid === "1934" || job.customerid === "1932" ? currency(job.currentprice) : currency(billable(job?.billable))}</Flex> {/*currency(job.currentprice) --- ${currency(billableitem(job.job))}*/}
          </Flexed>
    
      })
    }
    </Scroll>
    </>
  )
}

export default ActiveJobs